import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { Popover, PopoverPlacement, TextButton, Text } from '..';
import { TPAComponentsProvider } from '../TPAComponentsConfig';
import { classes } from './Popover.visual.st.css';

const PlacementArr: PopoverPlacement[] = ['top', 'right', 'bottom', 'left'];

visualize('Popover', () => {
  story('simple', () => {
    snap(
      'default props',
      <Popover placement="bottom" shown>
        <Popover.Element>
          <Text>This is the Popover.Element</Text>
        </Popover.Element>
        <Popover.Content>
          <div>This is the Popover.Content</div>
        </Popover.Content>
      </Popover>,
    );
    snap(
      'custom TextButton',
      <Popover placement="bottom" shown>
        <Popover.Element>
          <TextButton>This is the Popover.Element</TextButton>
        </Popover.Element>
        <Popover.Content>
          <div>This is the Popover.Content</div>
        </Popover.Content>
      </Popover>,
    );
    snap(
      'disable wiring',
      <Popover placement="bottom" wiredToSiteColors={false} shown>
        <Popover.Element>
          <Text>This is the Popover.Element</Text>
        </Popover.Element>
        <Popover.Content>
          <div>This is the Popover.Content</div>
        </Popover.Content>
      </Popover>,
    );

    story('style params override - border color', () => {
      PlacementArr.map((placement) => {
        snap(
          `placement: ${placement}`,
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '400px',
            }}
          >
            <Popover
              className={classes.borderColorStyleParam}
              placement={placement}
              wiredToSiteColors
              shown
            >
              <Popover.Element>
                <Text>This is the Popover.Element</Text>
              </Popover.Element>
              <Popover.Content>
                <div>This is the Popover.Content</div>
              </Popover.Content>
            </Popover>
          </div>,
        );
      });
    });

    snap(
      'style params override - border radius',
      <Popover
        className={classes.borderRadiusStyleParam}
        placement="bottom"
        wiredToSiteColors
        shown
      >
        <Popover.Element>
          <Text>This is the Popover.Element</Text>
        </Popover.Element>
        <Popover.Content>
          <div>This is the Popover.Content</div>
        </Popover.Content>
      </Popover>,
    );
    snap(
      'style params override - wst background color',
      <Popover
        className={classes.wstBackgroundColorParam}
        placement="bottom"
        shown
      >
        <Popover.Element>
          <Text>This is the Popover.Element</Text>
        </Popover.Element>
        <Popover.Content>
          <div>This is the Popover.Content</div>
        </Popover.Content>
      </Popover>,
    );
    snap(
      'rtl',
      <TPAComponentsProvider value={{ rtl: true }}>
        <Popover className={classes.root} placement="bottom">
          <Popover.Element>
            <Text>This is the Popover.Element</Text>
          </Popover.Element>
          <Popover.Content>
            <div>This is the Popover.Content</div>
          </Popover.Content>
        </Popover>
      </TPAComponentsProvider>,
    );
  });
  snap(
    'style params override - padding',
    <Popover
      className={classes.paddingStyleParam}
      placement="bottom"
      wiredToSiteColors
      shown
    >
      <Popover.Element>
        <Text>This is the Popover.Element</Text>
      </Popover.Element>
      <Popover.Content>
        <div>This is the Popover.Content</div>
      </Popover.Content>
    </Popover>,
  );
});
